import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            // staleTime: 60 * 60 * 1000, // 5 דקות
            // gcTime: 10 * 60 * 1000, // 10 דקות,
            // refetchOnMount: false,
            // refetchOnReconnect: false,
        },
    },
});

export const querySetting = {
    refetchOnMount: false,
    refetchOnReconnect: false,
    staleTime: 60 * 60 * 1000, // 5 דקות
    gcTime: 10 * 60 * 1000, // 10 דקות
}


const qc = {
    pendingAssessments: "pendingAssessments",
    versionOptions: "versionOptions",
    learningGroups: "learningGroups",
    learningGroupsForAffiliation: "learningGroupsForAffiliation",
    learningCenters: "learningCenters",
    assessmentResultsTrackingByAffiliations: "assessmentResultsTrackingByAffiliations",
    assessmentResultsTrackingByUserIds: "assessmentResultsTrackingByUserIds",
    adminAssessments: "adminAssessments",
    assessmentCosts: "assessmentCosts",
    adminAssessmentVersions: "adminAssessmentVersions",
    dataByUserIds: "dataByUserIds",
    assessmentExecution: "assessmentExecution",
    assignedCategories: "assignedCategories",
    interventionProfiles: "interventionProfiles",
    statusTypes: "statusTypes",
    regions: "regions",
    answers: "answers",
    assessmentVersion: "assessmentVersion",
    wrongWordsVersion: "wrongWordsVersion",
    words: "words",
    wordsVersions: "wordsVersions",
    languages: "languages",
    transcriptionUsers: "transcriptionUsers",
    methods: "methods",
    assessmentCount: "assessmentCount",
    users: "users",
    userOptions: "userOptions",
    tickets: "tickets",
    questions: "questions",
    readabilityScores: "readabilityScores",
    user: "user",
    report: "report",
    userRoles: "userRoles",
    userRoles2: "userRoles2",
    userData: "userData",
    roles: "roles",
    cities: "cities",
    fluencyStats: "fluencyStats",
    correctWordsPerMinute: "correctWordsPerMinute",
    watingForMarkingCount: "watingForMarkingCount",
    wordDefFrequency: "wordDefFrequency",
    newTicketCount: "newTicketCount",
    incorrectWordsFrequency: "incorrectWordsFrequency",
    wpmDistribution: "wpmDistribution",
    accuracyDistribution: "accuracyDistribution",
    ticketTypeCounts: "ticketTypeCounts",
    abilitiesGroup: "abilitiesGroup",
    batteries: "batteries",
    bateryAssessments: "bateryAssessments",
    profiles: "profiles",
    publishers: "publishers",
    assessmentDefTypes: "assessmentDefTypes",
    abilities: "abilities",
    studentFile: "studentFile",
    ticket: "ticket",
    ticketMessages: "ticketMessages",
    doughnutCharts: "doughnutCharts",
    percentAccuracyDoughnutChart: "percentAccuracyDoughnutChart",
    factoredPercentAccuracyDoughnut: "factoredPercentAccuracyDoughnut",
    fluencyDoughnut: "fluencyDoughnut",
    fluencyReadingDoughnut: "fluencyReadingDoughnut",
    correctWordsPerMinuteDoughnut: "correctWordsPerMinuteDoughnut",
    correctWordsPerMinuteBar: "correctWordsPerMinuteBar",
    prosodyDoughnut: "prosodyDoughnut",
    newsletters: "newsletters",
    userByTz: "userByTz",
    systemAreas: "systemAreas",
    newsletter: "newsletter",
    scoreRatingSemesters: "scoreRatingSemesters",
    factoredAccuracyDistribution: "factoredAccuracyDistribution",
    fluencyReadingDistribution: "fluencyReadingDistribution",
    correctWordsPerMinuteDistribution: "correctWordsPerMinuteDistribution",
    scoreRatingMethod: "scoreRatingMethod",
    affiliations: "affiliations",
    affiliationData: "affiliationData",
    affiliationGrades: "affiliationGrades",
    affiliationGroups: "affiliationGroups",
    affiliation: "affiliation",
    affiliationTeam: "affiliationTeam",
    affiliationUser: "affiliationUser",
    affiliationOptions: "affiliationOptions",
    assessment: "assessment",
    word: "word",
    exampleWordDefs: "exampleWordDefs",
    wordDefs: "wordDefs",
    matchingLearning: "matchingLearning",
    accuracyStats: "accuracyStats",
    readingFluencyStats: "readingFluencyStats",
    selfCorrectionStats: "selfCorrectionStats",
    minorErrorStats: "minorErrorStats",
    performAssessment: "performAssessment",
    factoredAccuracyGraph: "factoredAccuracyGraph",
    factoredAccuracyStats: "factoredAccuracyStats",
    testTaker: "testTaker",
    allGrades: "allGrades",
    categories: "categories",
    rating: "rating",
    ratings: "ratings",
    getAudioFile: "getAudioFile",
    netoAudioFile: "netoAudioFile",
    initAIServer: "initAIServer",
    whisper: "whisper",
    assessmentDef: "assessmentDef",
    assessmentDefs: "assessmentDefs",
    prices: "prices",
    allAssessmentDefs: "allAssessmentDefs",
    fluencyReadingStats: "fluencyReadingStats",
    correctWordsPerMinuteStats: "correctWordsPerMinuteStats",
    fluencyGraph: "fluencyGraph",
    hesitationsStats: "hesitationsStats",
    accuracyStatsByAssessment: "accuracyStatsByAssessment",
    markingMessages: "markingMessages",
    schoolClassess: "schoolClassess",
    nestedWords: "nestedWords",
    vowelCodes: "vowelCodes",
    letterAddOns: "letterAddOns",
    letterDescriptions: "letterDescriptions",
    assessments: "assessments",
    assessmentsTestTakers: "assessmentsTestTakers",
    getWithLastAssessments: "getWithLastAssessments",
    testTakers2: "testTakers2",
    studentBatteries: "studentBatteries",
    testTakers: "testTakers",
    testTakersOptions: "testTakersOptions",
    allTestTakers: "allTestTakers",
    grades: "grades",
    classes: "classes",
    dashboard: "dashboard",
    assessmentFrequency: "assessmentFrequency",
    assessmentFrequencyFactored: "assessmentFrequencyFactored",
    wordFrequency: "wordFrequency",
    assessmentAndWords: "assessmentAndWords",
    readingGroups: "readingGroups",
    learningCenterBreakdown: "learningCenterBreakdown"
}

export default qc